"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertSharedOptions = void 0;
function assertSharedOptions(_a) {
    var initiator = _a.initiator;
    if (initiator === undefined) {
        throw new Error('"initiator" parameter is required. Pass it via constructor or via showQuestion method');
    }
    return {
        initiator: initiator,
    };
}
exports.assertSharedOptions = assertSharedOptions;
//# sourceMappingURL=shared-options.utils.js.map